import useApi from "./useApi";

export const useAdminApi = () => {
  const { api, loading, error } = useApi({ showToast: true });

  // Dashboard stats
  const getStats = () =>
    api.get("/admin/v1/stats", {}, { showToast: false });

  // Subscriptions — per-user subscription status for dashboard
  const getSubscriptions = (params = {}) =>
    api.get("/admin/v1/subscriptions", params, { showToast: false });

  // Doctors — write operations only (reads via existing useDoctorsApi)
  const createDoctor = (body) => api.post("/doctors/v1/doctors", body);
  const updateDoctor = (id, body) => api.put(`/doctors/v1/doctors/${id}`, body);
  const deleteDoctor = (id) => api.delete(`/doctors/v1/doctors/${id}`);

  // Clinics CRUD
  const getClinics = (params = {}) =>
    api.get("/doctors/v1/clinics", params, { showToast: false });
  const createClinic = (body) => api.post("/doctors/v1/clinics", body);
  const updateClinic = (id, body) => api.put(`/doctors/v1/clinics/${id}`, body);

  // Availability
  const getDoctorAvailability = (doctorId) =>
    api.get(`/doctors/v1/doctors/${doctorId}/availability`, {}, { showToast: false });
  const updateDoctorAvailability = (doctorId, body) =>
    api.put(`/doctors/v1/doctors/${doctorId}/availability`, body);

  return {
    getStats,
    getSubscriptions,
    createDoctor,
    updateDoctor,
    deleteDoctor,
    getClinics,
    createClinic,
    updateClinic,
    getDoctorAvailability,
    updateDoctorAvailability,
    loading,
    error,
  };
};

export default useAdminApi;
